<div id="academy-courses" class="page-layout simple" (window:resize)="onResize($event)">
<div class="content p-24">
  <div class="barraSuperior" fxLayout="row" fxLayoutAlign="center center" >
    <button mat-button (click)="sidenav.toggle()">
    <mat-icon>menu</mat-icon>
    </button>
    <h1>Videos tutoriales</h1>
  </div>
<mat-sidenav-container class="containerSinedav" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
<mat-sidenav #sidenav mode="side" opened="{{barStatus}}" class="sinedav_One"
           [fixedInViewport]="options.value.fixed" [fixedTopGap]="options.value.top"
           [fixedBottomGap]="options.value.bottom">

        <div class="Menu">
          <div class="tituloMenu" fxLayout="row" fxLayoutAlign="center center">
          <h1><p><strong>Videos tutoriales</strong> CulturalGO® Reporting Platform</p></h1>
          </div>
        <mat-divider></mat-divider>

        <button mat-flat-button [ngStyle]="{'color':textoColorDimension,'background':colorDimension}" (click)="configuracionMenu(1)">
        <div fxLayout="row" fxLayoutAlign="space-around center" >
        <mat-icon>play_circle_outline</mat-icon>
        <h1><p>Dimension discovery</p></h1>
        </div>
        </button> <br>

        <button mat-flat-button [ngStyle]="{'color':textoColorDemographic,'background':colorDemographic}" (click)="configuracionMenu(2)">
        <div fxLayout="row" fxLayoutAlign="space-around center" >
        <mat-icon>play_circle_outline</mat-icon>
        <h1><p>Demographic finder</p></h1>
        </div>
        </button><br>

        <button mat-flat-button [ngStyle]="{'color':textoColorLeaders,'background':colorLeaders}" (click)="configuracionMenu(3)">
        <div fxLayout="row" fxLayoutAlign="space-around center" >
        <mat-icon>play_circle_outline</mat-icon>
        <h1><p>Leaders</p></h1>
        </div>
        </button><br>

        <button mat-flat-button [ngStyle]="{'color':textoColorComment,'background':colorComment}" (click)="configuracionMenu(4)">
        <div fxLayout="row" fxLayoutAlign="space-around center" >
        <mat-icon>play_circle_outline</mat-icon>
        <h1><p>Comment miner</p></h1>
        </div>
        </button><br>

        <button mat-flat-button [ngStyle]="{'color':textoColorExecutive,'background':colorExecutive}" (click)="configuracionMenu(5)">
        <div fxLayout="row" fxLayoutAlign="space-around center" >
        <mat-icon>play_circle_outline</mat-icon>
        <h1><p>Executive Summary</p></h1>
        </div>
        </button><br>

        <button mat-flat-button [ngStyle]="{'color':textoColorCorrelations,'background':colorCorrelations}" (click)="configuracionMenu(6)">
        <div fxLayout="row" fxLayoutAlign="space-around center" >
        <mat-icon>play_circle_outline</mat-icon>
        <h1><p>Correlations</p></h1>
        </div>
        </button><br>

        </div>

</mat-sidenav>

<mat-sidenav-content class="Sinedav_two" [formGroup]="options">
<cdk-virtual-scroll-viewport itemSize="50" class="example-viewport">
  <div *ngIf="dimensionStatus==true">
    <app-dimension-discovery></app-dimension-discovery>
  </div>

  <div *ngIf="demographicStatus==true">
    <app-domographic-finder></app-domographic-finder>
  </div>

  <div *ngIf="leadersStatus==true">
    <app-leaders></app-leaders>
  </div>

  <div *ngIf="commentsStatus==true">
    <app-comment-miner></app-comment-miner>
  </div>

  <div *ngIf="executiveStatus==true">
    <app-executive-summary></app-executive-summary>
  </div>

  <div *ngIf="correlationsStatus==true">
    <app-correlations></app-correlations>
  </div>

</cdk-virtual-scroll-viewport>

</mat-sidenav-content>
</mat-sidenav-container>

</div>
</div>
